import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcNearmeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.94 2.446c1.01-.384 1.998.605 1.614 1.614l-6.557 17.21c-.411 1.079-1.941 1.07-2.34-.013l-2.67-7.244-7.244-2.67c-1.083-.399-1.092-1.928-.012-2.34z"
  }));
}
var IcNearmeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNearmeFill));

export { IcNearmeFill as I };
